import { Observable, of } from 'rxjs';

import { SvgName } from 'src/app/app.config';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';

export type EnumPickerItem = { id: string; label: string; icon?: SvgName };

type EnumPickerContext = {
  options: EnumPickerItem[];
  allowClear: boolean;
};

export class EnumPickerHandler extends SmartPickerHandler<EnumPickerItem> {
  constructor(
    private context: EnumPickerContext,
    autoSelectSingleChoice?: boolean,
  ) {
    super({
      ...defaultSmartPickerOptions,
      filter: { enabled: false },
      preloadStrategy: {
        enabled: true,
        autoSelectSingleChoice: autoSelectSingleChoice !== undefined ? autoSelectSingleChoice : true,
      },
      showClear: context.allowClear,
    });
  }

  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<EnumPickerItem>> {
    const offset: number = params.offset ?? 0;
    const limit: number = params.limit ?? 20;
    let filteredOptions = this.context.options;
    if (params.query) {
      const q = params.query.toUpperCase();
      filteredOptions = filteredOptions.filter((option) => option.label.toUpperCase().includes(q));
    }
    const dummyItems: Array<EnumPickerItem> = filteredOptions.slice(offset, offset + limit).map((item) => item);
    const page = {
      count: filteredOptions.length,
      items: dummyItems,
      limit: limit,
      offset: offset,
    };
    return of(page);
  }
}
